<script>
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { mapGetters } from 'vuex';
import bowser from 'bowser';
import CheckBrowser from './views/main/check-browser';
import '@agrial/ui/dist/index.css';

export default {
  name: 'App',
  components: { CheckBrowser },
  computed: {
    ...mapGetters({
      showLoader: 'navigation/pending'
    }),
    /**
    * Retourne true si le navigateur utilisé à une version inférieure.
    */
    isBrowserCompatible () {
      const browser = bowser.getParser(window.navigator.userAgent);
      return browser.satisfies({
        chrome: '>=63',
        safari: '>=11.1',
        firefox: '>=67',
        edge: '>=79',
        opera: '>=50',
        samsungBrowser: '>=8.2',
        ios: '>=11.3'
      });
    },
    env () {
      return process.env.NODE_ENV.replace('development', 'dev');
    }
  }
};
</script>

<template>
  <v-app id="app">
    <Loader v-if="showLoader" />
    <CheckBrowser v-if="!isBrowserCompatible" />
    <router-view />
  </v-app>
</template>

<style lang="scss">
#app {
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  // overflow-x: scroll;
  // overflow-y: scroll;
  // height:100vh;
}

// @import "~vuetify/src/styles/settings/_variables";
// @media #{map-get($display-breakpoints, 'xs-only')} {
//   #app{
//     margin-bottom: 60px;
//   }
// }

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
